import createColorForIdTransformer from "../Core/createColorForIdTransformer";
export default createColorForIdTransformer();